export function forceHttps(url: string): string {
  return "https://" + url.replace(/https?:\/\//i, "");
}
